// Module
var code = "<div class=\"progress-stepper\"> <div class=\"small-line\"></div> <div class=\"status-icon\"> <span class=\"step-num\"></span> <span class=\"fa fa-check check\"></span> </div> <div class=\"name\">{{ title }}</div> </div> ";
// Exports
export default code;